/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PaymentTypeEnum;

(function (PaymentTypeEnum) {
  PaymentTypeEnum["PAYMENT"] = "payment";
  PaymentTypeEnum["REFUND"] = "refund";
})(PaymentTypeEnum || (PaymentTypeEnum = {}));